module.exports = __webpack_public_path__ + "workspace/static/img/renewalManagerTwo.e6cefbe.png";